import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, resolveFileUrl } from "../api";
import { PageHeader, EmptyState } from "../components/ui-bits";

export default function MerchPage() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");
  useEffect(() => { api.get("/products").then((r) => setItems(r.data)); }, []);
  const filtered = items.filter((p) => filter === "all" || p.category === filter);
  return (
    <div className="pb-32">
      <PageHeader
        kicker="THE SHOP"
        title="MERCH & GOODS"
        sub="Heavyweight cotton. Limited vinyl. Hardcover books. All built to outlive the trend cycle."
        right={
          <div className="flex gap-2">
            {[["all","All"],["merch","Merch"],["book","Books"]].map(([k,l]) => (
              <button key={k} onClick={() => setFilter(k)} className={`chip ${filter===k ? "chip-accent":""}`} data-testid={`merch-filter-${k}`}>
                {l.toUpperCase()}
              </button>
            ))}
          </div>
        }
      />
      <div className="divider-tape" />
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 py-10">
        {filtered.length === 0 ? <EmptyState>Restock incoming.</EmptyState> : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5" data-testid="merch-grid">
            {filtered.map((p) => (
              <Link key={p.id} to={`/merch/${p.id}`} className="card-brut block group" data-testid={`merch-card-${p.id}`}>
                <div className="aspect-[4/5] overflow-hidden">
                  <img src={resolveFileUrl(p.image)} alt={p.title} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
                </div>
                <div className="p-4 border-t border-neutral-800 flex justify-between items-center">
                  <div className="min-w-0">
                    <div className="font-headline text-sm uppercase truncate">{p.title}</div>
                    <div className="font-mono-label text-[10px] text-neutral-400 mt-1">{p.category.toUpperCase()}</div>
                  </div>
                  <div className="font-display text-2xl">${p.price.toFixed(0)}</div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
